import { gql } from '@apollo/client';

const ACCEPT_TERMS = gql`
  mutation AcceptTermsAndConditions($companyId: Int!, $product: String) {
    acceptTermsAndConditions(companyId: $companyId, product: $product) {
      user {
        id
        selectedCompany {
          id
          hasLendingAcceptedterms @client
          hasCollectionAcceptedTerms @client
          currentUserAcceptedTerms {
            id
            product
          }
        }
      }
    }
  }
`;

export default ACCEPT_TERMS;
